import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './redux/reducer';

import { getStyleValue } from './components/Helpers/Helpers';
import { createTheme } from '@mui/material/styles';
import App from './App';
import './index.css';

import { ThemeProvider } from '@mui/material';

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));
const store = createStore(rootReducer, composedEnhancer);

const theme = createTheme({
	overrides: {
		MuiAppBar: {
			colorPrimary: {
				'background-color': getStyleValue('color-navbar'),
			},
		},
	},
	palette: {
		type: 'light',
		primary: {
			main: '#26499E',
			constrastText: '#fff',
		},
		secondary: {
			main: '#EDEDED',
			dark: '#E0E0E0',
			contrastText: 'rgba(0, 0, 0, 0.87)',
		},
	},
	shape: {
		borderRadius: 3,
	},
	typography: {
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	},
});

const Root = () => {
	return (
		<ThemeProvider theme={theme}>
			<Provider store={store}>
				<App />
			</Provider>
		</ThemeProvider>
	);
};
ReactDOM.render(<Root />, document.getElementById('root'));
